export default __webpack_public_path__ + "static/media/l2-p1.5eb9ee7a.png";